export const GET_USER_CAMPAIGNS_SUCCESS = 'GET_USER_CAMPAIGNS_SUCCESS';
